module.exports = __webpack_public_path__ + "static/media/motor-active-icon.2f2991cf.svg";